import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, Route } from 'react-router-dom';
import CargomaticLogo from 'img/cargomatic-logo-dark.png';
import SessionStore from 'stores/SessionStore';
import { getClassName } from 'utils/ui/classes';
import { titleize } from 'underscore.string';
import classNames from 'classnames';
import UserActionCreators from '../../actions/UserActionCreators';
import CustomerSearch from './customer-search';
import ShipmentSearch from './shipment-search';
import SignedUrl from '../../utils/SignedUrlUtils';
import CargomaticPane from '../v2/pane';
import PlusIcon from '../v2/icons/PlusIcon';
import Navbar from '../v2/navs/Navbar';
import CollapsibleMenu from '../v2/navs/CollapsibleMenu';
import { isProd } from '../../helpers/helper_functions';
import LanguageSelector from './language-selector';
import { FloatingAIAssistant } from 'components/modules/shipments/assistant/AIAssistant';
const activeStyle = {
    fontWeight: 'bold',
};
const openReportsIndexPage = async () => {
    try {
        const url = await SignedUrl.getSignedUrl('reporting', 'index.html');
        window.open(url, 'new');
    }
    catch (e) {
        console.error('nav signed url: ', e);
    }
};
function logout() {
    UserActionCreators.logout();
}
const userDoesNotHaveShipperOrCarrierRole = () => {
    return !SessionStore.isShipper() && !SessionStore.isCarrier();
};
const hasAdminRole = () => {
    return SessionStore.getUserRoles().indexOf('admin') > -1;
};
const baseClassName = 'group flex items-center pl-10 pr-2 py-2 text-sm font-medium rounded-md cursor-pointer';
const Logo = (React.createElement(NavLink, { to: "/fleet" },
    React.createElement("img", { alt: "Cargomatic", src: CargomaticLogo })));
export default function SiteNav() {
    const [showNav, setShowNav] = useState(false);
    const { t } = useTranslation();
    const handleToggleMenu = () => {
        setShowNav(!showNav);
    };
    function hideNav() {
        setShowNav(false);
    }
    function renderNavItems() {
        return (React.createElement("div", { "data-testid": "navArea", className: "px-2 py-4 overflow-y-auto" },
            React.createElement(CollapsibleMenu, { title: t('SHIPMENTS_ORDERS') },
                React.createElement(NavLink, { "data-testid": "navCreateShipment", activeStyle: activeStyle, key: "booking", to: "/booking", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('CREATE_SHIPMENT'))),
                React.createElement("a", { "data-testid": "navCreateOrder", key: "order-booking", href: "/order-booking", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('CREATE_ORDER'))),
                React.createElement(NavLink, { "data-testid": "navViewAndCreateQuotes", activeStyle: activeStyle, key: "quotes", to: "/quotes", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('VIEW_AND_CREATE_QUOTES'))),
                React.createElement(NavLink, { "data-testid": "navViewShipments", activeStyle: activeStyle, key: "shipments", to: "/shipments", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('VIEW_SHIPMENTS'))),
                React.createElement(NavLink, { "data-testid": "navViewOrders", activeStyle: activeStyle, key: "orders", to: "/orders", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('VIEW_ORDERS'))),
                React.createElement(NavLink, { "data-testid": "navViewOffers", activeStyle: activeStyle, key: "loadboard", to: "/loadboard", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                        'admin-menu offers-offerlist heap',
                    ]) },
                    React.createElement("span", null, t('VIEW_OFFERS'))),
                !isProd() && (React.createElement(NavLink, { "data-testid": "navOfferPlanner", activeStyle: activeStyle, key: "offer-planner", to: "/offer-planner", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                        'admin-menu offers-offerlist heap',
                    ]) },
                    React.createElement("span", null, t('OFFER_PLANNER')))),
                userDoesNotHaveShipperOrCarrierRole() && (React.createElement("div", null,
                    React.createElement(NavLink, { "data-testid": "navUnifiedView", activeStyle: activeStyle, key: "unifiedview", to: "/unifiedview/favorites", onClick: hideNav, className: getClassName(baseClassName, [
                            'text-gray-600',
                            'hover:bg-gray-50',
                        ]) },
                        React.createElement("span", null, t('UNIFIED_VIEW'))))),
                !isProd() && (React.createElement(NavLink, { "data-testid": "navBulkShipmentCreation", activeStyle: activeStyle, key: "bulkshipmentcreation", to: "/bulk", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('BULK_SHIPMENT_CREATION'))))),
            React.createElement(CollapsibleMenu, { title: t('EXCEPTIONS') },
                React.createElement(NavLink, { "data-testid": "navExceptionAccessorials", activeStyle: activeStyle, key: "exceptions", to: "/exceptions/accessorials", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('ACCESSORIAL', { count: 2 }))),
                React.createElement(NavLink, { "data-testid": "navOrders", activeStyle: activeStyle, key: "order-exceptions", to: "/exceptions/orders", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, titleize(t('ORDER', { count: 2 })))),
                React.createElement(NavLink, { "data-testid": "navShipments", activeStyle: activeStyle, key: "shipment-exceptions", to: "/exceptions/shipments", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('SHIPMENT', { count: 2 }))),
                React.createElement(NavLink, { "data-testid": "navVCarrierDashboard", activeStyle: activeStyle, key: "carrier-dashboard", to: "/carriers/dashboard", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('CARRIER_DASHBOARD_TITLE')))),
            React.createElement(CollapsibleMenu, { title: t('MANAGE') },
                SessionStore.isAdmin() && (React.createElement(NavLink, { "data-testid": "navManageAccessorial", activeStyle: activeStyle, key: "accessorial-tools", to: "/tools/accessorials", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('ACCESSORIAL', { count: 2 })))),
                React.createElement(NavLink, { "data-testid": "navAppointments", activeStyle: activeStyle, key: "appointments", to: "/appointments", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('APPOINTMENTS'))),
                React.createElement(NavLink, { "data-testid": "navCustomers", activeStyle: activeStyle, key: "customers", to: "/customers", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('CUSTOMERS'))),
                React.createElement(NavLink, { "data-testid": "navEmptyReturnCustomers", activeStyle: activeStyle, key: "empty-return-instructions", to: "/empty-returns/instructions", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('EMPTY_RETURN_INSTRUCTIONS'))),
                React.createElement(NavLink, { "data-testid": "navEquipment", activeStyle: activeStyle, key: "equipment", to: "/equipment", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('EQUIPMENT'))),
                React.createElement(NavLink, { "data-testid": "navLocations", activeStyle: activeStyle, key: "locations", to: "/locations", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('LOCATIONS'))),
                React.createElement(NavLink, { "data-testid": "navWarehouse", activeStyle: activeStyle, key: "warehouse", to: "/manage/warehouse", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('WAREHOUSE'))),
                hasAdminRole() && (React.createElement(NavLink, { "data-testid": "navMarkets", activeStyle: activeStyle, key: "markets", to: "/markets", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, titleize(t('MARKET', { count: 2 }))))),
                SessionStore.isBridgeCodeManager() && (React.createElement(NavLink, { "data-testid": "navReasonCodes", activeStyle: activeStyle, to: "/reason_codes", key: "reason-codes", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('REASON_CODES')))),
                React.createElement(NavLink, { "data-testid": "navRegisterUsers", activeStyle: activeStyle, key: "users", to: "/users", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('REGISTER_USERS'))),
                React.createElement(NavLink, { "data-testid": "navTariffs", activeStyle: activeStyle, key: "tariffs", to: "/tools/tariffs", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('TARIFFS'))),
                React.createElement(NavLink, { "data-testid": "navTools", activeStyle: activeStyle, key: "tools", to: "/tools", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) }, t('TOOLS')),
                SessionStore.isACIAdmin() && (React.createElement(NavLink, { "data-testid": "navZones", activeStyle: activeStyle, key: "zones", to: "/tools/zones", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('ZONES')))),
                SessionStore.userAllowedToManageReferenceNumbersMasterList() && (React.createElement(NavLink, { "data-testid": "navReferenceNumbers", activeStyle: activeStyle, key: "referenceNumbers", to: "/tools/reference-numbers", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('REFERENCE_NUMBERS')))),
                hasAdminRole() && (React.createElement(NavLink, { activeStyle: activeStyle, key: "yards", to: "/yards", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, titleize(t('YARD_other', { count: 2 })))))),
            React.createElement(CollapsibleMenu, { title: t('PRICING') },
                React.createElement(NavLink, { "data-testid": "quickPay", activeStyle: activeStyle, key: "quick_pay", to: "/pricing/quick-pay", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('QUICK_PAY'))),
                SessionStore.isAdmin() && (React.createElement(NavLink, { "data-testid": "navLaneRates", activeStyle: activeStyle, key: "lane-rates", to: "/lane-rates", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('LANE_RATES')))),
                SessionStore.isAdmin() && (React.createElement(NavLink, { "data-testid": "navAccessorialRates", activeStyle: activeStyle, key: "accessorial-rates", to: "/accessorial-rates", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('ACCESSORIAL_RATES'))))),
            React.createElement(CollapsibleMenu, { title: t('ACCOUNTING') },
                React.createElement(NavLink, { "data-testid": "navInvoices", activeStyle: activeStyle, to: "/invoices", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('INVOICE', { count: 2 }))),
                React.createElement(NavLink, { "data-testid": "navPayouts", activeStyle: activeStyle, key: "payouts", to: "/payouts", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('PAYOUT', { count: 2 }))),
                SessionStore.isAdmin() && (React.createElement(NavLink, { "data-testid": "navCarrierCostBulkAuditTool", key: "carrier-bulk-audit-tool", to: "/carriers/bulk-audit-tool", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('CARRIER_COST_BULK_AUDIT_TOOL'))))),
            React.createElement(CollapsibleMenu, { title: t('REPORTING') },
                React.createElement("a", { "data-testid": "navCustomReports", href: "#", key: "reporting", className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]), onClick: (e) => {
                        e.preventDefault();
                        hideNav();
                        openReportsIndexPage();
                    } }, t('CUSTOM_REPORTS')),
                React.createElement(NavLink, { "data-testid": "navDaily", activeStyle: activeStyle, to: "/reporting/daily", key: "daily-reporting", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, titleize(t('DAILY')))),
                React.createElement(NavLink, { "data-testid": "navGrowth", activeStyle: activeStyle, to: "/reporting/growth", key: "growth-reporting", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('GROWTH')))),
            hasAdminRole() && (React.createElement(CollapsibleMenu, { title: t('MARKETPLACE_CONFIG') },
                React.createElement(NavLink, { "data-testid": "navMarkup", activeStyle: activeStyle, to: "/marketplace-config/markup", key: "markup-config", onClick: hideNav, className: getClassName(baseClassName, [
                        'text-gray-600',
                        'hover:bg-gray-50',
                    ]) },
                    React.createElement("span", null, t('MARKUP')))))));
    }
    function renderRightNav() {
        const items = [];
        items.push(React.createElement("div", { className: "flex items-center space-x-2", key: "search" },
            React.createElement("div", { className: "w-44 xl:w-60" },
                React.createElement(ShipmentSearch, null)),
            React.createElement("div", { className: "w-44 xl:w-60" },
                React.createElement(Route, { render: () => (React.createElement(CustomerSearch, { id: "customer-search-admin", onSelect: (_name, details) => {
                            window.location.href = `/users/${details.value}`;
                        }, menuStyle: {
                            position: 'fixed',
                            overflow: 'hidden',
                            maxHeight: '50vh',
                            zIndex: 100,
                            cursor: 'pointer',
                            overflowY: 'scroll',
                        } })) }))));
        items.push(React.createElement("div", { key: "language-selector", className: classNames('flex items-center justify-center nav-item', {
                hidden: LANGUAGE_SELECTION_DISABLED,
            }) },
            React.createElement(LanguageSelector, null)));
        items.push(React.createElement("a", { key: "signout", href: "#", className: "nav-item", onClick: logout }, t('SIGN_OUT')));
        return items;
    }
    function renderMobileNav(onClose) {
        const items = [];
        items.push(React.createElement("div", { className: "pl-2 flex flex-col space-y-2 justify-center items-start w-full", key: "mobile-search" },
            React.createElement("div", { className: "w-full" },
                React.createElement(ShipmentSearch, { closeOnSelect: true, onClose: onClose, menuStyle: {
                        position: 'fixed',
                        overflow: 'hidden',
                        maxHeight: '50vh',
                        zIndex: 100,
                        cursor: 'pointer',
                        overflowY: 'scroll',
                    } })),
            React.createElement("div", { className: "w-full mb-2" },
                React.createElement(Route, { render: ({ history }) => (React.createElement(CustomerSearch, { id: "customer-search-admin", onSelect: (_name, details) => {
                            history.push('/users/' + details.value);
                            onClose();
                        } })) }))));
        items.push(React.createElement(NavLink, { activeStyle: activeStyle, key: "mobile-booking", to: "/booking", className: "nav-item", onClick: onClose },
            React.createElement("span", null, t('CREATE_SHIPMENT'))));
        items.push(React.createElement(NavLink, { activeStyle: activeStyle, key: "mobile-quotes", to: "/quotes", className: "nav-item", onClick: onClose },
            React.createElement("span", null, t('VIEW_AND_CREATE_QUOTES'))));
        items.push(React.createElement(NavLink, { activeStyle: activeStyle, key: "mobile-shipments", to: "/shipments", className: "nav-item", onClick: onClose },
            React.createElement("span", null, t('VIEW_SHIPMENTS'))));
        items.push(React.createElement(NavLink, { activeStyle: activeStyle, key: "loadboard", to: "/loadboard", className: "nav-item admin-mobile-menu offers-offerlist heap", onClick: onClose },
            React.createElement("span", null, t('VIEW_OFFERS'))));
        items.push(React.createElement("a", { key: "mobile-order-booking", href: "/order-booking", className: "nav-item", onClick: onClose },
            React.createElement("span", null, t('CREATE_ORDER'))));
        items.push(React.createElement(NavLink, { activeStyle: activeStyle, key: "mobile-orders", to: "/orders", className: "nav-item", onClick: onClose },
            React.createElement("span", null, t('VIEW_ORDERS'))));
        items.push(React.createElement("div", { key: "language-selector-mobile", className: classNames('nav-item', {
                hidden: LANGUAGE_SELECTION_DISABLED,
            }) },
            React.createElement(LanguageSelector, { mobile: true })));
        items.push(React.createElement("a", { key: "mobile-signout", href: "#", className: "nav-item", onClick: (e) => {
                e.preventDefault();
                logout();
            } }, t('SIGN_OUT')));
        return items;
    }
    function renderSidebar() {
        return (React.createElement(CargomaticPane, { show: showNav, onHide: hideNav, title: "Navigation", location: "left", renderBody: renderNavItems, width: 0.25 }));
    }
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("div", { id: "pane-container" }, renderSidebar()),
            React.createElement(Navbar, { logo: Logo, showLeftMenuToggle: true, renderRightNav: renderRightNav, renderMobileNav: renderMobileNav, mainNavOpen: showNav, onToggleOpen: handleToggleMenu }, [
                React.createElement(NavLink, { activeStyle: activeStyle, key: "nav-booking", to: "/booking", className: "flex-grow-0 flex-shrink-0 cursor button button-green hover:text-white" },
                    React.createElement("div", { className: "flex items-center space-x-2" },
                        React.createElement(PlusIcon, null),
                        React.createElement("span", { className: "" }, t('SHIPMENT', { count: 1 })))),
                React.createElement("a", { key: "nav-order-booking", href: "/order-booking", className: "flex-grow-0 flex-shrink-0 nav-item cursor button button-blue" },
                    React.createElement("div", { className: "flex items-center space-x-2" },
                        React.createElement(PlusIcon, null),
                        React.createElement("span", { className: "" }, titleize(t('ORDER', { count: 1 }))))),
                React.createElement(NavLink, { activeStyle: activeStyle, key: "nav-shipments", to: "/shipments", className: "hidden nav-item xl:block" },
                    React.createElement("span", null, t('SHIPMENT', { count: 2 }))),
            ].filter(Boolean))),
        SessionStore.hasRole('beta-ai') && React.createElement(FloatingAIAssistant, null)));
}
